import React from 'react';
import { toast } from 'react-toastify';
// import axios from '../axios-common';
import tokenStorage from '../storage/Token';
import { getMessageFromRequest } from '../utils/errors';
import api from '../api';

const { Provider, Consumer } = React.createContext();

class UserProvider extends React.PureComponent {
	state = {
		user: null,
		isLogged: !!tokenStorage.get(),
		isLoading: false,
	};

	componentDidMount() {
		this.updateUserFromToken();
	}

	getUserFromToken = async () => {
		const token = tokenStorage.get();
		if (!token) return { isLogged: false, user: null };
		try {
			const { data: user } = await api.account.users.getCurrentUser();
			return { isLogged: true, user };
		} catch (err) {
			if (err.message === 'Network Error') {
				toast.error('Não foi possivel acessar o servidor');
				return { isLogged: false };
			}
			toast.error(`Erro ao validar o usuário: ${err.message}`);
			return { isLogged: false, user: null };
		}
	};

	updateUserFromToken = async () => {
		const tokenState = await this.getUserFromToken();
		this.setState(tokenState);
	};

	logout = () => {
		localStorage.removeItem('app.authToken');
		this.setState({ isLogged: false, user: null });
	};

	login = async (username, password) => {
		this.logout();
		this.setState({ isLoading: true });
		try {
			const { data: token } = await api.account.users.login({
				username,
				password,
			});
			tokenStorage.save(token);
			const tokenState = await this.getUserFromToken();
			this.setState(tokenState);
		} catch (err) {
			const responseStatus = err?.response?.data?.status;
			const responseError = err?.response?.data?.error;
			const responseMessage = err?.response?.data?.message;

			if (responseStatus === 401) {
				toast.error('Usuário ou senha incorreto.');
			} else {
				toast.error(`ERRO: ${responseError}: ${responseMessage}`);
			}
		} finally {
			this.setState({ isLoading: false });
		}
	};

	renewAuthorities = async () => {
		try {
			// const { data: token } = await axios.get('/api/account/users/renew-authorities');
			const { data: token } = await api.account.users.renewAuthorities();
			tokenStorage.save(token);
		} catch (err) {
			const message = getMessageFromRequest(err);
			toast.error(message || 'Usuário inválido.');
		}
	};

	render() {
		const { children } = this.props;
		const context = {
			login: this.login,
			logout: this.logout,
			isLoading: this.state.isLoading,
			// getUser: this.getUser,
			renewAuthorities: this.renewAuthorities,
			...this.state,
		};
		return <Provider value={context}>{children}</Provider>;
	}
}

// Injects the menu state
export function withUser(Component) {
	return function UserComponent(props) {
		return (
			<Consumer>
				{(context) => (
					<Component userProps={context.user} {...props} {...context} />
				)}
			</Consumer>
		);
	};
}

export default UserProvider;
